// extracted by mini-css-extract-plugin
module.exports = {"dashboardIframe":"GrafnaDashboard_dashboardIframe__2HKuL"};